import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  DownloadedFile,
  listDownloads,
  removeDownload,
} from "../../../services/downloads";

const DownloadsList = () => {
  const [items, setItems] = useState<DownloadedFile[]>([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const load = async () => {
    setLoading(true);
    const data = await listDownloads();
    setItems(data);
    setLoading(false);
  };

  useEffect(() => {
    load();
  }, []);

  const openItem = (item: DownloadedFile) => {
    const params = new URLSearchParams({
      name: item.name,
      uri: item.uri,
      mime: item.mimeType,
    }).toString();
    navigate(`/customer/documents/view?${params}`);
  };

  const deleteItem = async (id: string) => {
    await removeDownload(id);
    load();
  };

  return (
    <div className="container p-3">
      <div className="row pb-2">
        <div className="col">
          <h5 className="text-light">Documents</h5>
          <p className="text-secondary">Saved to device Documents folder</p>
        </div>
      </div>
      {loading ? (
        <div className="text-secondary">Loading...</div>
      ) : items.length === 0 ? (
        <div className="text-secondary">No saved documents yet</div>
      ) : (
        <div className="list-group">
          {items.map((it) => (
            <div
              key={it.id}
              className="list-group-item d-flex justify-content-between align-items-center"
            >
              <div style={{ cursor: "pointer" }} onClick={() => openItem(it)}>
                <div className="text-light">{it.name}</div>
                <div className="text-secondary" style={{ fontSize: 12 }}>
                  Saved {new Date(it.savedAt).toLocaleString()}
                </div>
                <div className="text-secondary" style={{ fontSize: 12 }}>
                  {it.mimeType}
                </div>
              </div>
              <button
                className="btn btn-sm btn-outline-danger"
                onClick={() => deleteItem(it.id)}
              >
                Remove
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default DownloadsList;
